
import isEmpty from 'lodash/isEmpty'

export const MODEL_VARIANTS = {
  LARGE: 'large',
  SMALL: 'small',
}

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: Array,
      required: true,
    },
    variant: {
      type: String,
      validator: (variant) => Object.values(MODEL_VARIANTS).includes(variant),
      default: MODEL_VARIANTS.LARGE,
    },
  },

  computed: {
    displaySubTitle() {
      return !isEmpty(this.subTitle)
    },

    subTitleLabel() {
      return this.displaySubTitle && this.subTitle.join(' - ')
    },

    mainTitleAttributes() {
      switch (this.variant) {
        case MODEL_VARIANTS.SMALL:
          return { class: 'body-1-bold' }

        default:
          // TODO: BROW-1273 Remove this class override when Design-System titles are updated.
          return {
            class: 'title-1 !text-[2.2rem] md:!text-[2.8rem]',
          }
      }
    },
  },
}
